import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function CallIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="0 0 34 34"
    >
      <G fill={color} fillRule="evenodd">
        <Path
          d="M22.417 24.172c.34 0 .632-.025.862-.054l.16-.02.095-.133c.937-1.31 1.174
          -2.968 1.206-4.128l.007-.175-.13-.116c-1.167-1.036-3.12-1.777-4.667-1.76l-.122.002
          -.098.073c-.402.3-1.1 1.032-1.498 1.527-.58-.29-1.282-.933-2.092-1.917-.81-.986-1.305
          -1.798-1.477-2.423.562-.295 1.415-.84 1.787-1.175l.09-.082.026-.12c.313-1.504-.034
          -3.573-.825-4.918l-.088-.15-.173-.03c-.977-.164-3.13-.083-4.65.608l-.148.067-.052.154c
          -.675 2.006-.152 5.72 3.345 10.142 3.383 3.957 6.63 4.63 8.442 4.63zM11.29 9.796c1.317
          -.544 3.06-.604 3.892-.51.614 1.148.895 2.855.674 4.108-.432.352-1.354.92-1.77 1.1l
          -.257.114.037.28c.11.802.664 1.802 1.695 3.055 1.03 1.253 1.904 1.99 2.67 2.253l.267.09.16
          -.23c.26-.37.993-1.167 1.422-1.523 1.274.025 2.896.632 3.903 1.458-.046 1.002-.26 2.332
          -.967 3.403-1.444.143-4.838-.083-8.465-4.327-3.21-4.06-3.766-7.486-3.262-9.27z"
        />
        <Path
          d="M17 33.5c9.113 0 16.5-7.387 16.5-16.5S26.113.5 17 .5.5 7.887.5 17 7.887 33.5 17 33.5zm0
          -1C8.44 32.5 1.5 25.56 1.5 17 1.5 8.44 8.44 1.5 17 1.5c8.56 0 15.5 6.94 15.5 15.5
          0 8.56-6.94 15.5-15.5 15.5z"
        />
      </G>
    </Svg>
  );
}

CallIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

CallIcon.defaultProps = {
  height: 21,
  width: 32,
};

export default pure(CallIcon);
